import { render, staticRenderFns } from "./BCXPeopleIcon.vue?vue&type=template&id=21848e78"
import script from "./BCXPeopleIcon.vue?vue&type=script&lang=ts"
export * from "./BCXPeopleIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports